import React, { useRef, useState } from 'react'
import Modal from 'react-responsive-modal'
import { useFormik } from 'formik'
import { useSelector } from 'react-redux'
import ModalFooter from '../../../../components/ModalFooter/ModalFooter'
import styles from './styles.module.css'

const QUARTER_FIELDS = [
  { suffix: 'ach',   label: 'Мои самые большие достижения' },
  { suffix: 'impr',  label: 'Мои самые яркие впечатления' },
  { suffix: 'think', label: 'Последнее время я думал(а) над вопросом' },
]

const ALL_TABS = [
  { key: 'about',   label: 'Немного о себе' },
  { key: 'school',  label: 'Я и моё Учебное заведение' },
  { key: 'q1',      label: '1 Четверть' },
  { key: 'q2',      label: '2 Четверть' },
  { key: 'q3',      label: '3 Четверть' },
  { key: 'q4',      label: '4 Четверть' },
  { key: 'map',     label: 'Карта моих достижений' },
  { key: 'choice',  label: 'Мой выбор' },
  { key: 'teacher', label: 'Страница преподавателя' },
  { key: 'parent',  label: 'Отзывы родителей' },
]

const CREATE_TABS = [
  { key: 'teacher', label: 'Страница преподавателя' },
]

const SECTION_FIELDS = {
  about: [
    { name: 'family',  label: 'Я и моя семья' },
    { name: 'love',    label: 'Больше всего я люблю' },
    { name: 'values',  label: 'Самыми ценными качествами в людях я считаю' },
    { name: 'wishes',  label: 'В этом году мне хотелось бы' },
    { name: 'proud',   label: 'Я горжусь собой, потому что' },
  ],
  school: [
    { name: 'fav_subjects', label: 'Моими любимыми предметами я считаю (потому что)' },
    { name: 'year_wish',    label: 'В этом учебном году мне бы хотелось' },
    { name: 'year_must',    label: 'Для этого я должен (-на)' },
    { name: 'clubs',        label: 'Я посещаю следующие кружки и секции' },
    { name: 'clubs_hope',   label: 'Я надеюсь это даст мне возможность' },
  ],
  map: [
    { name: 'map_academic', label: 'Учебные достижения в рамках программы (отличник, хорошист, победитель олимпиад, игр по предмету).' },
    { name: 'map_extra',    label: 'Достижения в дополнительном образовании (кружки, секции, музыкальные и художественные школы и т.п.).' },
    { name: 'map_sport',    label: 'Спортивные достижения.' },
    { name: 'map_public',   label: 'Участие в общественной работе.' },
    { name: 'map_other',    label: 'Другие виды деятельности.' },
    { name: 'map_success',  label: 'Что я считаю личным успехом.' },
  ],
  choice: [
    { name: 'choice_why',    label: 'Выбор специализации – важный шаг для меня, потому что' },
    { name: 'choice_likes',  label: 'Мне нравится изучать' },
    { name: 'choice_spec',   label: 'и, скорее всего, я выберу специализацию по' },
    { name: 'choice_good',   label: 'Я делаю большие успехи в изучении' },
    { name: 'choice_impact', label: 'и это повлияет на мой выбор специализации, потому что' },
    { name: 'choice_final',  label: 'Я окончательно выбрал(а) специализацию по' },
    { name: 'choice_right',  label: 'и считаю свой выбор правильным, так как' },
    { name: 'choice_future', label: 'В будущем я вижу себя' },
  ],
  teacher: [
    { name: 'teacher_wishes', label: 'Пожелания преподавателей' },
  ],
  parent: [
    { name: 'parent_ach',     label: 'В чём Вы видите основные достижения Вашего ребенка за прошедший период?' },
    { name: 'parent_changes', label: 'Какие изменения, на Ваш взгляд, произошли с Вашим ребёнком в течение учебного года?' },
  ],
}

export default function PortfolioModal({ data, closeModal, addMode, onSave }) {
  const tabs = addMode ? CREATE_TABS : ALL_TABS
  const [activeTab, setActiveTab] = useState(tabs[0].key)
  const tabListRef = useRef(null)

  const { schoolYears } = useSelector(state => state.common)

  const { values, handleChange, handleSubmit, setFieldValue } = useFormik({
    initialValues: { ...(data || {}), year: data?.xp_key || '' },
    enableReinitialize: true,
    onSubmit: (vals) => {
      const selectedYear = (schoolYears || []).find(y => String(y.xp_key) === String(vals.year))
      onSave({ ...vals, xp_key: vals.year, year_name: selectedYear?.name || data?.year_name || '' })
    },
  })

  const scrollTabs = (dir) => {
    if (tabListRef.current) {
      tabListRef.current.scrollLeft += dir * 120
    }
  }

  const renderRows = (fields) =>
    fields.map(({ name, label }) => (
      <div key={name} className={styles.pfRow}>
        <span className={styles.pfLabel}>{label}</span>
        <textarea
          className={styles.pfTextarea}
          name={name}
          value={values[name] || ''}
          onChange={handleChange}
        />
      </div>
    ))

  const renderContent = () => {
    const qMatch = activeTab.match(/^q([1-4])$/)
    if (qMatch) {
      const n = qMatch[1]
      return renderRows(QUARTER_FIELDS.map(f => ({ name: `q${n}_${f.suffix}`, label: f.label })))
    }
    const fields = SECTION_FIELDS[activeTab]
    return fields ? renderRows(fields) : null
  }

  return (
    <Modal
      open={true}
      onClose={() => false}
      showCloseIcon={false}
      center
      classNames={{ modal: styles.portfolioModal }}
    >
      <div className={styles.modalHeader}>
        {addMode ? 'Добавление' : 'Изменение'}
      </div>

      <div className={styles.pfYearRow}>
        <span>Учебный год</span>
        <select
          className={styles.pfYearSelect}
          value={values.year || ''}
          disabled={!addMode}
          onChange={e => setFieldValue('year', e.target.value)}
        >
          <option value=''>—</option>
          {(schoolYears || []).map(y => (
            <option key={y.xp_key} value={y.xp_key}>{y.name}</option>
          ))}
        </select>
      </div>

      <div className={styles.pfTabBar}>
        <button type='button' className={styles.pfTabArrow} onClick={() => scrollTabs(-1)}>◄</button>
        <div className={styles.pfTabList} ref={tabListRef}>
          {tabs.map(tab => (
            <button
              key={tab.key}
              type='button'
              className={activeTab === tab.key ? styles.pfTabActive : styles.pfTab}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <button type='button' className={styles.pfTabArrowRight} onClick={() => scrollTabs(1)}>►</button>
      </div>

      <div className={styles.pfContent}>
        {renderContent()}
      </div>

      <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
    </Modal>
  )
}
